import React, { useState, useEffect } from 'react';
import * as env from 'config/environment';
import { Link, useParams } from 'react-router-dom';
import { formatDate } from 'utils/formatter';
import Loading from 'components/commons/loading/Loading';
import { categoryNames } from 'pages/NotificationList';
import { NotificationItems } from './Login';
import Icon from 'components/commons/icon/Icon';
import Footer from 'components/commons/Footer';
import { HeadBlock } from './components/HeadBlock';

function autoLink(content: string): string {
  const regexpUrl = /(?<url>https?:\/\/[-_.!~*'()a-zA-Z0-9;/?:@&=+$,%#]+)(\[:b (?<text>.*)\]){0,1}/g;

  return content.replace(regexpUrl, (...args) => {
    const groups = args.pop();
    const url = groups['url'];
    const text = groups['text'];

    const target = url.startsWith(env.appURL) ? '' : 'target="_blank"';
    if (text) {
      return `<div class="ui-button theme-outline my-4 mx-4 p-2"><a class="text-link" href="${url}" ${target}>${text}</a></div>`;
    } else {
      return `<a class=${'text-link'} href="${url}" ${target}>${url}</a>`;
    }
  });
}

function createContent(
  content: string | undefined
): {
  __html: string;
} {
  return { __html: autoLink(unescape(content ?? '')) };
}

const LoginNotificationDetail: React.FC = () => {
  const { notificationID } = useParams<{
    notificationID: string;
  }>();

  const [notificationItems, setNotificationItems] = useState<
    NotificationItems[] | null
  >(null);

  const headers = {
    Accept: 'application/json',
  };

  useEffect(() => {
    document.domain === 'localhost'
      ? (async () => {
          const res = await fetch(
            `https://stg.tw.minkabu.jp/status/notifications.json`,
            {
              cache: 'no-cache',
              method: 'GET',
              headers,
            }
          );
          if (res.status === 200) {
            setNotificationItems((await res.json()) as NotificationItems[]);
          }
        })()
      : (async () => {
          const res = await fetch(`${env.appURL}/status/notifications.json`, {
            cache: 'no-cache',
            method: 'GET',
            headers,
          });
          if (res.status === 200) {
            setNotificationItems((await res.json()) as NotificationItems[]);
          }
        })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!notificationItems)
    return (
      <Loading
        loading={true}
        style={{
          backgroundColor: '#edf2f7',
          alignItems: 'normal',
          paddingTop: '200px',
          top: '95',
          left: '0',
        }}
      />
    );

  const item = notificationItems.find(items => items.ID === notificationID);

  if (!item) {
    return <>お知らせが見つかりません。</>;
  }

  const title = unescape(item.Title ?? '');

  return (
    <>
      <HeadBlock />
      <div className="flex flex-col scrollable h-full">
        <div className="flex-grow">
          <header
            className="bg-gray-100 border-b-2 border-gray-300"
            id="id_header">
            <nav className="flex p-2">
              <div
                className="flex-1 flex justify-start"
                style={{ minWidth: '72px' }}>
                <Link to="/">
                  <button className="flex items-center p-2">
                    <Icon
                      name="chevron-left"
                      className="text-2xl text-gray-700"
                    />
                  </button>
                </Link>
              </div>

              <h1 className="font-bold text-center p-2 truncate-420">
                お知らせ詳細
              </h1>
              <div className="flex-1 flex justify-end"></div>
            </nav>
          </header>

          <div className="container" id="id_container">
            <div className="bg-white rounded m-3 p-3">
              <div className="flex text-gray-500 text-sm p-2">
                <div className="">
                  {formatDate(
                    new Date(item.UpdTime ? item.UpdTime : item.InsTime),
                    'yyyy/MM/dd HH:mm'
                  )}
                </div>
                <div className="ml-6">{categoryNames[item.Type]}</div>
              </div>
              <div className="break-all p-2">
                <div className="font-bold">{title}</div>
                <div
                  className="mt-4 whitespace-pre-wrap"
                  dangerouslySetInnerHTML={createContent(item.Content)}
                />
              </div>
            </div>
          </div>
        </div>
        <Footer showFooterMarginTop={true} />
      </div>
    </>
  );
};

export default LoginNotificationDetail;
